import { createContext } from "react";

import { CareElementConfig } from "./CareElements/CareElementConfig";

export interface ICareComponentConfigurationContext {
    /**
     * The name of the care component
     */
    careComponentName: string;

    /**
     * The care elements that are currently configured
     */
    careElements: CareElementConfig[];

    /**
     * The care elements that are available to be added to the configuration
     */
    availableElements: CareElementConfig[];

    /**
     * The function to call when removing a care element
     */
    onRemove: (careElementName: string) => void;

    /**
     * The function to call when adding a care element
     */
    onAdd: (careElementName: string) => void;

    /**
     * The function to call when editing a care element configuration
     */
    onEdit: (careElementName: string, careElementConfig: CareElementConfig) => void;

    /**
     * The function to validate care element configuration
     */
    isCareElementInvalid: (careElementName: string) => boolean;
}

export const CareComponentConfigurationContext = createContext<ICareComponentConfigurationContext>({
    careComponentName: "",
    careElements: [],
    availableElements: [],
    onRemove: () => { },
    onAdd: () => { },
    onEdit: () => { },
    isCareElementInvalid: () => false
});
